import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, FormControl, UntypedFormControl } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { Subject, tap } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HeadService } from 'src/app/services/common/headservice';
import * as $ from 'jquery';
import { DateObject, ModuleMenu } from 'src/app/models/common';
import { DatePipe } from '@angular/common';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';

@Component({
  selector: 'app-grants-general-information-sponsorship',
  templateUrl: './grants-general-information-sponsorship.component.html',
  styleUrls: ['./grants-general-information-sponsorship.component.scss']
})
export class GrantsGeneralInformationSponsorshipComponent implements OnInit , IDeactivateComponent {

  generalInformationForm: UntypedFormGroup;
  permission: string = "";
  staticformFields: any;
  THERAPEUTIC_AREA_ID: any[];
  DETAILED_PURPOSE: any[];
  IS_HP_ATTENDING: any[];
  SPONSERSHIP_LEVEL: any[];
  IS_OTH_SPONSERSHIP: any[];
  IS_OTH_FIN_SUPPORT: any[];
  IS_USED_POLITICAL	: any[];
  IS_USED_COPAYMENTS	: any[];
  IS_USED_OTH_ACTIVITY	: any[];
  IS_USED_MEALS			: any[];
  IS_ACCREDITED_SPONSORED	: any[];
  IS_HELD_PROGRAM	: any[];
  IS_PRE_SUPPORTED : any[];
  CURRENCY_SYMBOL:any;
  action: Subject<any> = new Subject();
  userType: string = "";
  heading: string;
  operations: any = [];
  ApplicationID: any;
  menudata: ModuleMenu;
  ProgramStartDate: Date = new Date();
  ProgramEndDate: Date = new Date();
  minPStartDate : Date 
  maxPStartDate: Date | undefined;
  minPEndDate : Date 
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  Application_Type_ID: string="";
  constructor(
    public commonService: CommonService,
    private userService: UserService,
    private DatashareSerivce: GrantsDatashareService,
    private summaryService: GrantsSummaryService,
    public route: ActivatedRoute,
    private router: Router,
    private header: HeadService,
    private datepipe: DatePipe
  ) {
    //this.setFormPermissions();
    this.Application_Type_ID = route.snapshot.queryParams['ApplicationType'];
  }

  ngOnInit() {
    this.minPEndDate = new Date();
    this.minPStartDate = new Date();
    this.userType = this.userService.getUserType();
    this.DatashareSerivce.GrantApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.getStaticFiledsData('GSP01');
    this.generalInformationForm = new UntypedFormGroup(
      {
        ID: new UntypedFormControl(""),
        APPLICATION_CODE: new UntypedFormControl(""),
        APPLICATIONID: new UntypedFormControl(""),
        APPLICATION_TITLE: new UntypedFormControl(""),
        THERAPEUTIC_AREA_ID		: new UntypedFormControl(""),
        PROGRAM_TITLE			: new UntypedFormControl(""),
        DETAILED_PURPOSE	: new UntypedFormControl(""),
        IS_HP_ATTENDING		: new UntypedFormControl(""),
        SPONSERSHIP_LEVEL		: new UntypedFormControl(""),
        IS_OTH_SPONSERSHIP	: new UntypedFormControl(""),
        PROGRAM_START_DATE	: new UntypedFormControl(""),
        PROGRAM_END_DATE		: new UntypedFormControl(""),
        REQUEST_AMOUNT			: new UntypedFormControl(""),
        TAX_DEDUCTED			: new UntypedFormControl(""),
        TOTAL_BUDGET			: new UntypedFormControl(""),
        IS_OTH_FIN_SUPPORT	: new UntypedFormControl(""),
        ANNUAL_BUDGET_PERCENTAGE: new UntypedFormControl(""),
        IS_USED_POLITICAL		: new UntypedFormControl(""),
        IS_USED_COPAYMENTS	: new UntypedFormControl(""),
        IS_USED_OTH_ACTIVITY	: new UntypedFormControl(""),
        IS_USED_MEALS			: new UntypedFormControl(""),
        IS_ACCREDITED_SPONSORED	: new UntypedFormControl(""),
        IS_HELD_PROGRAM			: new UntypedFormControl(""),
        IS_PRE_SUPPORTED		: new UntypedFormControl("")
      });
      this.generalInformationForm.markAsPristine();
      // setTimeout(() => {      
      //   this.setFormPermissions();
      //   if (this.permission == "view") {
      //     this.generalInformationForm.disable();
      //   }
      //   else 
      //   {
      //     this.generalInformationForm.enable();
      //   }
      // }, 500);


    this.summaryService.getGeneralInformationCME("api/GMAPPSponsorship/GetMasterList?ApplicationID=" + this.ApplicationID).subscribe((summary) => {

      if (summary != null && summary != undefined) {
         
        this.generalInformationForm.patchValue({
          ID: summary["ID"],
          APPLICATION_CODE: summary["APPLICATION_CODE"],
          APPLICATIONID: summary["APPLICATIONID"],
          APPLICATION_TITLE: summary["APPLICATION_TITLE"],
          THERAPEUTIC_AREA_ID		: summary["THERAPEUTIC_AREA_ID"],
          PROGRAM_TITLE			: summary["PROGRAM_TITLE"],
          DETAILED_PURPOSE		: summary["DETAILED_PURPOSE"],
          IS_HP_ATTENDING		: summary["IS_HP_ATTENDING"],
          SPONSERSHIP_LEVEL		: summary["SPONSERSHIP_LEVEL"],
          IS_OTH_SPONSERSHIP	: summary["IS_OTH_SPONSERSHIP"],
          PROGRAM_START_DATE	: summary["PROGRAM_START_DATE"],
          PROGRAM_END_DATE	: summary["PROGRAM_END_DATE"],
          REQUEST_AMOUNT	: summary["REQUEST_AMOUNT"],
          TAX_DEDUCTED		: summary["TAX_DEDUCTED"],
          TOTAL_BUDGET		: summary["TOTAL_BUDGET"],
          IS_OTH_FIN_SUPPORT	: summary["IS_OTH_FIN_SUPPORT"],
          ANNUAL_BUDGET_PERCENTAGE : summary["ANNUAL_BUDGET_PERCENTAGE"],
          IS_USED_POLITICAL		: summary["IS_USED_POLITICAL"],
          IS_USED_COPAYMENTS		: summary["IS_USED_COPAYMENTS"],
          IS_USED_OTH_ACTIVITY	: summary["IS_USED_OTH_ACTIVITY"],
          IS_USED_MEALS			: summary["IS_USED_MEALS"],
          IS_ACCREDITED_SPONSORED	: summary["IS_ACCREDITED_SPONSORED"],
          IS_HELD_PROGRAM			: summary["IS_HELD_PROGRAM"],
          IS_PRE_SUPPORTED		: summary["IS_PRE_SUPPORTED"]
        });
        this.permission=summary["PERMISSION"];
        if (summary["PROGRAM_START_DATE"] != null && summary["PROGRAM_START_DATE"] != "") {
          this.ProgramStartDate = this.commonService.getdisplayedDate(this.generalInformationForm.controls["PROGRAM_START_DATE"].value);
          this.generalInformationForm.controls["PROGRAM_START_DATE"].setValue(this.ProgramStartDate);
          if(this.ProgramStartDate < new Date()){
            this.minPStartDate = this.ProgramStartDate;
          }
        }
        if (summary["PROGRAM_END_DATE"] != null && summary["PROGRAM_END_DATE"] != "") {
          this.ProgramEndDate = this.commonService.getdisplayedDate(this.generalInformationForm.controls["PROGRAM_END_DATE"].value);
          this.generalInformationForm.controls["PROGRAM_END_DATE"].setValue(this.ProgramEndDate);
          if(this.ProgramEndDate < new Date()){
            this.minPEndDate = this.ProgramEndDate;
          }
        }
       this.THERAPEUTIC_AREA_ID = summary["TherapeuticAreaList"];
       this.THERAPEUTIC_AREA_ID = [{ label: "Select", value: null, checked: true }].concat(this.THERAPEUTIC_AREA_ID);
       
       this.SPONSERSHIP_LEVEL = summary["SponsorshiplevelList"];
       this.SPONSERSHIP_LEVEL = [{ label: "Select", value: null, checked: true }].concat(this.SPONSERSHIP_LEVEL);
       this.CURRENCY_SYMBOL= summary["CURRENCY_SYMBOL"];
        if (this.extendedForm != undefined && this.extendedForm != null) {
          this.extendedForm.rowid = summary["ID"];
          this.extendedForm.getResponse();
        }
        // By using this permission, page state needs to control.
        if (this.permission == "view") {
          this.generalInformationForm.disable();
        }
        this.setFormPermissions();
      }
    });

    this.commonService.getGlobalDirtyInfo().subscribe((res)=>{
      if(res==true){
        this.generalInformationForm.markAsPristine();
         this.extendedForm.IsFormToched=false;
      }
    });
 
  }

  private setFormPermissions() {
  //  this.permission = "";
   // this.permission = this.commonService.getPagePermission("GSP01");
    if (this.permission == "view") {
      if (this.extendedForm != null && this.extendedForm != undefined) {
        this.extendedForm.permission = this.permission;
        this.extendedForm.ScreenMode = this.permission;
      }
      // this.generalInformationForm.disable();
    }

    if (this.permission == "view") {
      // this.generalInformationForm.disable();
      this.operations = [];
    }
    else {
      this.operations = [
        {
          name: 'SaveGeneralInfo', type: 'submit', callback: this.SaveGeneralInfo, self: this
        }
      ];
    }
    if (this.permission == "view" && this.generalInformationForm != undefined && this.generalInformationForm != null) {
      this.generalInformationForm.disable();
    }
    else if (this.generalInformationForm != undefined && this.generalInformationForm != null) {
      this.generalInformationForm.enable();
    } 
  }

 getStaticFiledsData(screenCode:string) {
  this.commonService.getScreenStaticFields(screenCode,this.ApplicationID)
    .subscribe(summary => {
      this.staticformFields = summary["Data"];
      this.DETAILED_PURPOSE=this.staticformFields.DETAILED_PURPOSE.GROUP_VALUES_LIST;
      this.DETAILED_PURPOSE = [{ label: "Select", value: null, checked: true }].concat(this.DETAILED_PURPOSE);
      this.IS_HP_ATTENDING =this.staticformFields.IS_HP_ATTENDING.GROUP_VALUES_LIST;
      this.IS_HP_ATTENDING = [{ label: "Select", value: null, checked: true }].concat(this.IS_HP_ATTENDING);
      this.IS_OTH_SPONSERSHIP = this.staticformFields.IS_OTH_SPONSERSHIP.GROUP_VALUES_LIST;
      this.IS_OTH_SPONSERSHIP = [{ label: "Select", value: null, checked: true }].concat(this.IS_OTH_SPONSERSHIP);
      this.IS_OTH_FIN_SUPPORT = this.staticformFields.IS_OTH_FIN_SUPPORT.GROUP_VALUES_LIST;
      this.IS_OTH_FIN_SUPPORT = [{ label: "Select", value: null, checked: true }].concat(this.IS_OTH_FIN_SUPPORT);
      this.IS_USED_POLITICAL		 = this.staticformFields.IS_USED_POLITICAL.GROUP_VALUES_LIST;
      this.IS_USED_POLITICAL = [{ label: "Select", value: null, checked: true }].concat(this.IS_USED_POLITICAL);
      this.IS_USED_COPAYMENTS	 = this.staticformFields.IS_USED_COPAYMENTS.GROUP_VALUES_LIST;
      this.IS_USED_COPAYMENTS = [{ label: "Select", value: null, checked: true }].concat(this.IS_USED_COPAYMENTS);
      this.IS_USED_OTH_ACTIVITY	 = this.staticformFields.IS_USED_OTH_ACTIVITY.GROUP_VALUES_LIST;
      this.IS_USED_OTH_ACTIVITY = [{ label: "Select", value: null, checked: true }].concat(this.IS_USED_OTH_ACTIVITY);
      this.IS_USED_MEALS	 = this.staticformFields.IS_USED_MEALS.GROUP_VALUES_LIST;
      this.IS_USED_MEALS = [{ label: "Select", value: null, checked: true }].concat(this.IS_USED_MEALS);
      this.IS_ACCREDITED_SPONSORED	 = this.staticformFields.IS_ACCREDITED_SPONSORED.GROUP_VALUES_LIST;
      this.IS_ACCREDITED_SPONSORED = [{ label: "Select", value: null, checked: true }].concat(this.IS_ACCREDITED_SPONSORED);
      this.IS_HELD_PROGRAM		 = this.staticformFields.IS_HELD_PROGRAM.GROUP_VALUES_LIST;
      this.IS_HELD_PROGRAM = [{ label: "Select", value: null, checked: true }].concat(this.IS_HELD_PROGRAM);
      this.IS_PRE_SUPPORTED		 = this.staticformFields.IS_PRE_SUPPORTED.GROUP_VALUES_LIST;
      this.IS_PRE_SUPPORTED = [{ label: "Select", value: null, checked: true }].concat(this.IS_PRE_SUPPORTED);
    });
}

onCallbackOperation(opr) {
  opr.callback(this.summaryService, this.generalInformationForm, this.DatashareSerivce);
}

CompareDates(olddate: any, newDate: any): boolean {
  if (olddate != '' && olddate != undefined && olddate != null) {

    let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
    let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
    if (oDt == nDt) { return true }
    else { return false }
  }
  else
    return false
}


startDateSelect(event) {
 // this.minPEndDate = event;
  this.isStartDateModified = true
  this.Full_Start_Date = {
    Day: event.getDate(),
    Month: (event.getMonth() + 1),
    Year: event.getFullYear(),
    Hours: 0,
    Minutes: 0,
    Seconds: 0,
    IsEndDate: false,
    HasValue: true,
    IsDateModified: this.isStartDateModified
  }
}

endDateSelect(event) {
 // this.maxPStartDate = event;
  this.isEndDateModified = true;
  this.Full_End_Date = {
    Day: event.getDate(),
    Month: (event.getMonth() + 1),
    Year: event.getFullYear(),
    Hours: 23,
    Minutes: 59,
    Seconds: 59,
    IsEndDate: true,
    HasValue: true,
    IsDateModified: this.isEndDateModified
  }
}

GetStartDate(): DateObject {
  var formModel = this.generalInformationForm.getRawValue();
  const lDate = new Date(formModel.PROGRAM_START_DATE);
  if ((this.CompareDates(this.ProgramStartDate, lDate) || this.Full_Start_Date == null || this.Full_Start_Date == undefined) && formModel.PROGRAM_START_DATE != null) {
    this.Full_Start_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: false
    }
  }
  else{
    this.Full_Start_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: true
    }
  }
  return this.Full_Start_Date
}

GetEndDate(): DateObject {
  const formModel = this.generalInformationForm.getRawValue();
  const lDate = new Date(formModel.PROGRAM_END_DATE);
  if ((this.CompareDates(this.ProgramEndDate, lDate) || this.Full_End_Date == null || this.Full_End_Date == undefined) && formModel.PROGRAM_END_DATE != null)
    this.Full_End_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: false
    }
    else{
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
  return this.Full_End_Date;
}

SaveGeneralInfo() {
  if (this.validateControls()) {
    this.generalInformationForm.markAsPristine();
    var formData = this.generalInformationForm.value;
    formData.APPLICATION_TITLE=formData.APPLICATION_TITLE==null?null:formData.APPLICATION_TITLE== undefined?undefined:formData.APPLICATION_TITLE.trim();
    formData.PROGRAM_TITLE =formData.PROGRAM_TITLE==null?null:formData.PROGRAM_TITLE== undefined?undefined:formData.PROGRAM_TITLE.trim();
    formData.TAX_DEDUCTED=formData.TAX_DEDUCTED==null?null:formData.TAX_DEDUCTED== undefined?undefined:formData.TAX_DEDUCTED.trim();
    formData.ANNUAL_BUDGET_PERCENTAGE=formData.ANNUAL_BUDGET_PERCENTAGE== null?null:formData.ANNUAL_BUDGET_PERCENTAGE==undefined?undefined:formData.ANNUAL_BUDGET_PERCENTAGE.trim();
   formData.TOTAL_BUDGET=formData.TOTAL_BUDGET==null?null:formData.TOTAL_BUDGET== undefined?undefined:formData.TOTAL_BUDGET.trim();
    formData['PROGRAM_START_DATEO'] = this.GetStartDate();
      formData['PROGRAM_END_DATEO'] = this.GetEndDate();
      formData['PROGRAM_END_DATE'] = new Date();
      formData['PROGRAM_START_DATE'] = new Date();

    this.DETAILED_PURPOSE.forEach(obj => {
      if (obj.value!=null && obj.value!="" && formData["DETAILED_PURPOSE"] == obj.value) {
        formData.DETAILED_PURPOSE_NAME = obj.label;
      }
    });
    this.IS_HP_ATTENDING.forEach(obj => {
      if (obj.value!=null && obj.value!="" && formData["IS_HP_ATTENDING"] == obj.value) {
        formData.IS_HP_ATTENDING_NAME = obj.label;
      }
    });
  this.IS_OTH_SPONSERSHIP.forEach(obj => {
    if (obj.value!=null && obj.value!="" && formData["IS_OTH_SPONSERSHIP"] == obj.value) {
      formData.IS_OTH_SPONSERSHIP_NAME = obj.label;
    }
  });
  this.IS_OTH_FIN_SUPPORT.forEach(obj => {
    if (obj.value!=null && obj.value!="" && formData["IS_OTH_FIN_SUPPORT"] == obj.value) {
      formData.IS_OTH_FIN_SUPPORT_NAME = obj.label;
    }
  });
  this.IS_USED_POLITICAL.forEach(obj => {
    if (obj.value!=null && obj.value!="" && formData["IS_USED_POLITICAL"] == obj.value) {
      formData.IS_USED_POLITICAL_NAME = obj.label;
    }
  });
  this.IS_USED_COPAYMENTS.forEach(obj => {
    if (obj.value!=null && obj.value!="" && formData["IS_USED_COPAYMENTS"] == obj.value) {
      formData.IS_USED_COPAYMENTS_NAME = obj.label;
    }
  });
  this.IS_USED_OTH_ACTIVITY.forEach(obj => {
    if (obj.value!=null && obj.value!="" && formData["IS_USED_OTH_ACTIVITY"] == obj.value) {
      formData.IS_USED_OTH_ACTIVITY_NAME = obj.label;
    }
  });
  this.IS_USED_MEALS.forEach(obj => {
    if (obj.value!=null && obj.value!="" && formData["IS_USED_MEALS"] == obj.value) {
      formData.IS_USED_MEALS_NAME = obj.label;
    }
  });
  this.IS_ACCREDITED_SPONSORED.forEach(obj => {
    if (obj.value!=null && obj.value!="" && formData["IS_ACCREDITED_SPONSORED"] == obj.value) {
      formData.IS_ACCREDITED_SPONSORED_NAME = obj.label;
    }
  });
  this.IS_HELD_PROGRAM.forEach(obj => {
    if (obj.value!=null && obj.value!="" && formData["IS_HELD_PROGRAM"] == obj.value) {
      formData.IS_HELD_PROGRAM_NAME = obj.label;
    }
  });
  this.IS_PRE_SUPPORTED.forEach(obj => {
    if (obj.value!=null && obj.value!="" && formData["IS_PRE_SUPPORTED"] == obj.value) {
      formData.IS_PRE_SUPPORTED_NAME = obj.label;
    }
  });

    if (this.ApplicationID == "" || this.ApplicationID == undefined) {
      formData.Application_Type_ID=this.Application_Type_ID;
      this.summaryService.SaveCMEGeneralInfo("api/GMAPPSponsorship/Insert", formData).subscribe((result) => {
        var tempID = result.Data;
        this.ApplicationID = result.Data;
        this.DatashareSerivce.setGrantApplicationID(tempID);
        this.generalInformationForm.markAsPristine();
        if (result.Status === 0) {
              this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
                if (result1.Status === 0) {
                  this.extendedForm.IsFormToched=false;
                  this.commonService.SuccessBanner(result.Message);
                  this.refreshPage(tempID,result.TransactionID);
                }
                else {
                  this.commonService.ValidationBanner(result1.Message);
                  this.refreshPage(tempID,result.TransactionID);
                  if (this.extendedForm != null && this.extendedForm != undefined) {
                    this.extendedForm.getResponse();
                  }
                }
              });
        }
        else {
          this.commonService.ValidationBanner(result.Message);
        }
      });
    }
    else {
            this.summaryService.SaveCMEGeneralInfo("api/GMAPPSponsorship/Update", formData).subscribe((result) => {
              if (result.Status === 0 || result.ErrorCode === "NOCHANGES") {
                this.generalInformationForm.markAsPristine();
                    this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
                      if (result1.ErrorCode === "NOCONTROLS") {
                        if (result.ErrorCode === "NOCHANGES")
                          this.commonService.ValidationBanner(result.Message);
                        else
                        {
                          this.generalInformationForm.markAsPristine();
                          this.commonService.SuccessBanner("General Information saved successfully");
                          this.extendedForm.IsFormToched=false;
                          if (this.extendedForm != null && this.extendedForm != undefined) {
                            this.extendedForm.rowid=result.TransactionID;
                            this.extendedForm.getResponse();
                          }
                        }
                      }
                      else {
                        if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                          this.commonService.ValidationBanner(result.Message);
                        }
                        else {
                          this.generalInformationForm.markAsPristine();
                          this.commonService.SuccessBanner("General Information saved successfully");
                          this.extendedForm.IsFormToched=false;
                          if (this.extendedForm != null && this.extendedForm != undefined) {
                            this.extendedForm.rowid=result.TransactionID;
                            this.extendedForm.getResponse();
                          }
                        }
                      }

                    });

              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
            });
    }
  }
}

refreshPage(idAPP: any,PKID:any) {
  this.summaryService.getCMEApplicationSummary("api/common/getgrantsapp/" + idAPP).subscribe(data => {
    this.commonService.appId = idAPP;
    this.commonService.ScreenID = PKID;
    this.commonService.setGrantsApp(data);
    this.menudata = new ModuleMenu();
    this.menudata.module = "GRANTSSPONSORSHIP";
    this.menudata.operation = "Edit";
    this.menudata.appId = idAPP;
    this.menudata.screenID=PKID;
    this.menudata.formstate = "Draft";
    this.commonService.setModluleMenu(this.menudata);
    this.DatashareSerivce.setGrantApplicationID(idAPP);
    this.header.setHeader(this.menudata);
    this.generalInformationForm.patchValue({
      ID: PKID});
      this.router.navigate(['/home/grants/my-applications/application-ext/:'+idAPP+'/'+data.StartMenu], { skipLocationChange: true, queryParams: { module: "grants",submodule:this.menudata.module , id: PKID, app_ext: true, screen_type: "my-applications" }
    });

  });
  this.generalInformationForm.markAsPristine();
}

redirectTo(uri: string) {
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    this.router.navigate([uri]));
}

validateControls(): boolean {
  let isValid = true;
  let message = "";
  const formData = this.generalInformationForm.value;
  if (this.staticformFields?.APPLICATION_TITLE?.IS_Display && this.staticformFields?.APPLICATION_TITLE.IS_MANDATORY) {
    if (formData.APPLICATION_TITLE === null || formData.APPLICATION_TITLE === ""||formData.APPLICATION_TITLE === undefined) {
      $("#APPLICATION_TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#APPLICATION_TITLE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.APPLICATION_TITLE.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.APPLICATION_TITLE != null && formData.APPLICATION_TITLE != undefined && formData.APPLICATION_TITLE.trim()==""){
      $("#APPLICATION_TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#APPLICATION_TITLE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.APPLICATION_TITLE.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#APPLICATION_TITLE").addClass("ng-untouched ng-valid");
      $("#APPLICATION_TITLE").removeClass("ng-touched ng-invalid validate-error");
    }
  }
  if (this.staticformFields?.THERAPEUTIC_AREA_ID?.IS_Display && this.staticformFields?.THERAPEUTIC_AREA_ID.IS_MANDATORY) {
    if (formData.THERAPEUTIC_AREA_ID === null || formData.THERAPEUTIC_AREA_ID === "") {
      $("#THERAPEUTIC_AREA_ID").addClass("ng-touched ng-invalid validate-error");
      $("#THERAPEUTIC_AREA_ID").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.THERAPEUTIC_AREA_ID.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#THERAPEUTIC_AREA_ID").addClass("ng-untouched ng-valid");
      $("#THERAPEUTIC_AREA_ID").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.PROGRAM_TITLE?.IS_Display && this.staticformFields?.PROGRAM_TITLE.IS_MANDATORY) {
    if (formData.PROGRAM_TITLE === null || formData.PROGRAM_TITLE === ""||formData.PROGRAM_TITLE=== undefined) {
      $("#PROGRAM_TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#PROGRAM_TITLE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.PROGRAM_TITLE.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.PROGRAM_TITLE != null && formData.PROGRAM_TITLE != undefined && formData.PROGRAM_TITLE.trim()==""){
      $("#PROGRAM_TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#PROGRAM_TITLE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.PROGRAM_TITLE.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#PROGRAM_TITLE").addClass("ng-untouched ng-valid");
      $("#PROGRAM_TITLE").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.DETAILED_PURPOSE?.IS_Display && this.staticformFields?.DETAILED_PURPOSE.IS_MANDATORY) {
    if (formData.DETAILED_PURPOSE === null || formData.DETAILED_PURPOSE === "") {
      $("#DETAILED_PURPOSE").addClass("ng-touched ng-invalid validate-error");
      $("#DETAILED_PURPOSE").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.DETAILED_PURPOSE.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#DETAILED_PURPOSE").addClass("ng-untouched ng-valid");
      $("#DETAILED_PURPOSE").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_HP_ATTENDING?.IS_Display && this.staticformFields?.IS_HP_ATTENDING.IS_MANDATORY) {
    if (formData.IS_HP_ATTENDING === null || formData.IS_HP_ATTENDING === "") {
      $("#IS_HP_ATTENDING").addClass("ng-touched ng-invalid validate-error");
      $("#IS_HP_ATTENDING").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_HP_ATTENDING.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_HP_ATTENDING").addClass("ng-untouched ng-valid");
      $("#IS_HP_ATTENDING").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.SPONSERSHIP_LEVEL?.IS_Display && this.staticformFields?.SPONSERSHIP_LEVEL.IS_MANDATORY) {
    if (formData.SPONSERSHIP_LEVEL === null || formData.SPONSERSHIP_LEVEL === "") {
      $("#SPONSERSHIP_LEVEL").addClass("ng-touched ng-invalid validate-error");
      $("#SPONSERSHIP_LEVEL").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.SPONSERSHIP_LEVEL.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#SPONSERSHIP_LEVEL").addClass("ng-untouched ng-valid");
      $("#SPONSERSHIP_LEVEL").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_OTH_SPONSERSHIP?.IS_Display && this.staticformFields?.IS_OTH_SPONSERSHIP.IS_MANDATORY) {
    if (formData.IS_OTH_SPONSERSHIP === null || formData.IS_OTH_SPONSERSHIP === "") {
      $("#IS_OTH_SPONSERSHIP").addClass("ng-touched ng-invalid validate-error");
      $("#IS_OTH_SPONSERSHIP").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_OTH_SPONSERSHIP.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_OTH_SPONSERSHIP").addClass("ng-untouched ng-valid");
      $("#IS_OTH_SPONSERSHIP").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.PROGRAM_START_DATE?.IS_Display && this.staticformFields?.PROGRAM_START_DATE.IS_MANDATORY) {
    if (formData.PROGRAM_START_DATE === null || formData.PROGRAM_START_DATE === "") {
      $("#PROGRAM_START_DATE").addClass("ng-touched ng-invalid validate-error");
      $("#PROGRAM_START_DATE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.PROGRAM_START_DATE.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#PROGRAM_START_DATE").addClass("ng-untouched ng-valid");
      $("#PROGRAM_START_DATE").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.PROGRAM_END_DATE?.IS_Display && this.staticformFields?.PROGRAM_END_DATE.IS_MANDATORY) {
    if (formData.PROGRAM_END_DATE === null || formData.PROGRAM_END_DATE === "") {
      $("#PROGRAM_END_DATE").addClass("ng-touched ng-invalid validate-error");
      $("#PROGRAM_END_DATE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.PROGRAM_END_DATE.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#PROGRAM_END_DATE").addClass("ng-untouched ng-valid");
      $("#PROGRAM_END_DATE").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if(this.staticformFields?.PROGRAM_START_DATE?.IS_Display && this.staticformFields?.PROGRAM_END_DATE?.IS_Display)
    {
       if (formData.PROGRAM_START_DATE != null && formData.PROGRAM_END_DATE != null)
      {
      if (new Date(formData.PROGRAM_START_DATE) > new Date(formData.PROGRAM_END_DATE)) 
      {
        message += "Program end date cannot be lesser than program start date. Please update the details";
        isValid = false;
      }
    }
    }

  if (this.staticformFields?.REQUEST_AMOUNT?.IS_Display && this.staticformFields?.REQUEST_AMOUNT.IS_MANDATORY) {
    if (formData.REQUEST_AMOUNT === null || formData.REQUEST_AMOUNT === "") {
      $("#REQUEST_AMOUNT").addClass("ng-touched ng-invalid validate-error");
      $("#REQUEST_AMOUNT").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.REQUEST_AMOUNT.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#REQUEST_AMOUNT").addClass("ng-untouched ng-valid");
      $("#REQUEST_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.TAX_DEDUCTED?.IS_Display && this.staticformFields?.TAX_DEDUCTED.IS_MANDATORY) {
    if (formData.TAX_DEDUCTED === null || formData.TAX_DEDUCTED === ""||formData.TAX_DEDUCTED=== undefined) {
      $("#TAX_DEDUCTED").addClass("ng-touched ng-invalid validate-error");
      $("#TAX_DEDUCTED").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TAX_DEDUCTED.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.TAX_DEDUCTED!= null && formData.TAX_DEDUCTED!= undefined && formData.TAX_DEDUCTED.trim()==""){
      $("#TAX_DEDUCTED").addClass("ng-touched ng-invalid validate-error");
      $("#TAX_DEDUCTED").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TAX_DEDUCTED.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#TAX_DEDUCTED").addClass("ng-untouched ng-valid");
      $("#TAX_DEDUCTED").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.TOTAL_BUDGET?.IS_Display && this.staticformFields?.TOTAL_BUDGET.IS_MANDATORY) {
    if (formData.TOTAL_BUDGET === null || formData.TOTAL_BUDGET === ""||formData.TOTAL_BUDGET===undefined) {
      $("#TOTAL_BUDGET").addClass("ng-touched ng-invalid validate-error");
      $("#TOTAL_BUDGET").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TOTAL_BUDGET.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.TOTAL_BUDGET!= null&&formData.TOTAL_BUDGET!= undefined&&formData.TOTAL_BUDGET.trim()==""){
      $("#TOTAL_BUDGET").addClass("ng-touched ng-invalid validate-error");
      $("#TOTAL_BUDGET").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TOTAL_BUDGET.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#TOTAL_BUDGET").addClass("ng-untouched ng-valid");
      $("#TOTAL_BUDGET").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_OTH_FIN_SUPPORT?.IS_Display && this.staticformFields?.IS_OTH_FIN_SUPPORT.IS_MANDATORY) {
    if (formData.IS_OTH_FIN_SUPPORT === null || formData.IS_OTH_FIN_SUPPORT === "") {
      $("#IS_OTH_FIN_SUPPORT").addClass("ng-touched ng-invalid validate-error");
      $("#IS_OTH_FIN_SUPPORT").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_OTH_FIN_SUPPORT.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_OTH_FIN_SUPPORT").addClass("ng-untouched ng-valid");
      $("#IS_OTH_FIN_SUPPORT").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.ANNUAL_BUDGET_PERCENTAGE?.IS_Display && this.staticformFields?.ANNUAL_BUDGET_PERCENTAGE.IS_MANDATORY) {
    if (formData.ANNUAL_BUDGET_PERCENTAGE === null || formData.ANNUAL_BUDGET_PERCENTAGE === ""||formData.ANNUAL_BUDGET_PERCENTAGE=== undefined) {
      $("#ANNUAL_BUDGET_PERCENTAGE").addClass("ng-touched ng-invalid validate-error");
      $("#ANNUAL_BUDGET_PERCENTAGE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.ANNUAL_BUDGET_PERCENTAGE.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.ANNUAL_BUDGET_PERCENTAGE != null && formData.ANNUAL_BUDGET_PERCENTAGE != undefined && formData.ANNUAL_BUDGET_PERCENTAGE.trim()==""){
      $("#ANNUAL_BUDGET_PERCENTAGE").addClass("ng-touched ng-invalid validate-error");
      $("#ANNUAL_BUDGET_PERCENTAGE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.ANNUAL_BUDGET_PERCENTAGE.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#ANNUAL_BUDGET_PERCENTAGE").addClass("ng-untouched ng-valid");
      $("#ANNUAL_BUDGET_PERCENTAGE").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_USED_POLITICAL?.IS_Display && this.staticformFields?.IS_USED_POLITICAL.IS_MANDATORY) {
    if (formData.IS_USED_POLITICAL === null || formData.IS_USED_POLITICAL === "") {
      $("#IS_USED_POLITICAL").addClass("ng-touched ng-invalid validate-error");
      $("#IS_USED_POLITICAL").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_USED_POLITICAL.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_USED_POLITICAL").addClass("ng-untouched ng-valid");
      $("#IS_USED_POLITICAL").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_USED_COPAYMENTS?.IS_Display && this.staticformFields?.IS_USED_COPAYMENTS.IS_MANDATORY) {
    if (formData.IS_USED_COPAYMENTS === null || formData.IS_USED_COPAYMENTS === "") {
      $("#IS_USED_COPAYMENTS").addClass("ng-touched ng-invalid validate-error");
      $("#IS_USED_COPAYMENTS").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_USED_COPAYMENTS.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_USED_COPAYMENTS").addClass("ng-untouched ng-valid");
      $("#IS_USED_COPAYMENTS").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_USED_OTH_ACTIVITY?.IS_Display && this.staticformFields?.IS_USED_OTH_ACTIVITY.IS_MANDATORY) {
    if (formData.IS_USED_OTH_ACTIVITY === null || formData.IS_USED_OTH_ACTIVITY === "") {
      $("#IS_USED_OTH_ACTIVITY").addClass("ng-touched ng-invalid validate-error");
      $("#IS_USED_OTH_ACTIVITY").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_USED_OTH_ACTIVITY.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_USED_OTH_ACTIVITY").addClass("ng-untouched ng-valid");
      $("#IS_USED_OTH_ACTIVITY").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_USED_MEALS?.IS_Display && this.staticformFields?.IS_USED_MEALS.IS_MANDATORY) {
    if (formData.IS_USED_MEALS === null || formData.IS_USED_MEALS === "") {
      $("#IS_USED_MEALS").addClass("ng-touched ng-invalid validate-error");
      $("#IS_USED_MEALS").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_USED_MEALS.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_USED_MEALS").addClass("ng-untouched ng-valid");
      $("#IS_USED_MEALS").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_ACCREDITED_SPONSORED?.IS_Display && this.staticformFields?.IS_ACCREDITED_SPONSORED.IS_MANDATORY) {
    if (formData.IS_ACCREDITED_SPONSORED === null || formData.IS_ACCREDITED_SPONSORED === "") {
      $("#IS_ACCREDITED_SPONSORED").addClass("ng-touched ng-invalid validate-error");
      $("#IS_ACCREDITED_SPONSORED").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_ACCREDITED_SPONSORED.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_ACCREDITED_SPONSORED").addClass("ng-untouched ng-valid");
      $("#IS_ACCREDITED_SPONSORED").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_HELD_PROGRAM?.IS_Display && this.staticformFields?.IS_HELD_PROGRAM.IS_MANDATORY) {
    if (formData.IS_HELD_PROGRAM === null || formData.IS_HELD_PROGRAM === "") {
      $("#IS_HELD_PROGRAM").addClass("ng-touched ng-invalid validate-error");
      $("#IS_HELD_PROGRAM").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_HELD_PROGRAM.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_HELD_PROGRAM").addClass("ng-untouched ng-valid");
      $("#IS_HELD_PROGRAM").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_PRE_SUPPORTED?.IS_Display && this.staticformFields?.IS_PRE_SUPPORTED.IS_MANDATORY) {
    if (formData.IS_PRE_SUPPORTED === null || formData.IS_PRE_SUPPORTED === "") {
      $("#IS_PRE_SUPPORTED").addClass("ng-touched ng-invalid validate-error");
      $("#IS_PRE_SUPPORTED").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_PRE_SUPPORTED.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_PRE_SUPPORTED").addClass("ng-untouched ng-valid");
      $("#IS_PRE_SUPPORTED").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  let ExtenMsgs = this.extendedForm.validateControlsMsgs();
  if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
    isValid = false;
    message = message + this.extendedForm.validateControlsMsgs();
  }

  if (!isValid)
    this.commonService.ValidationBanner(message);
  return isValid;
}
canExit() {
  if (this.generalInformationForm.dirty || this.extendedForm.IsFormToched) {
    return this.commonService.CanDeactivateBanner();
  }
  else {
    return Promise.resolve(true);
  }
}

}
